
/**
 * Module dependencies.
 */

import { ImageSources, Media } from 'types/media';

/**
 * Export `getImageSources`.
 */

export const getImageSources = (filename: string, extension: string, retinaSuffix = '@2x'): ImageSources => ({
  defaultUrl: require(`client/assets/images/${filename}.${extension}`),
  retinaUrl: require(
    `client/assets/images/${filename}${retinaSuffix}.${extension}`
  )
});

/**
 * Export `resolveImageUrl`.
 */

export function resolveImageUrl(media: Media | null | undefined): string | null {
  if (!media || media?.status === 'processing') {
    return null;
  }

  const { thumbnailUrl, type, url } = media as any;

  switch (type) {
    case 'image':
      return url;

    case 'video':
      return thumbnailUrl;

    default:
      return null;
  }
}
